import React from 'react';
import BlankCanvasLayout from '../sharedComponents/BlankCanvasLayout/BlankCanvasLayout';
import SandSwitchLayout from '../sharedComponents/SandSwitchLayout/SandSwitchLayout';
import SnowLayout from '../sharedComponents/SnowLayout/SnowLayout';
import SandSplitLayout from '../sharedComponents/SandSplitLayout/SandSplitLayout';
import {
  Home,
  Login,
  MyTrips,
  Notification,
  PageProps,
  PayoutManagement,
  Profile,
  PurchaseGuarantee,
  Signup,
  TripDetails,
} from '../pages';
import { LayoutProps } from '../sharedComponents/types';
import NewDecoration from '../sharedComponents/NewDecoration/NewDecoration';

type RouteConfigBase = {
  path: string;
  nameDecoration?: React.FC;
  element: React.FC<PageProps>;
  layout: React.FC<LayoutProps>;
  private: boolean;
  displayInNavigation: boolean;
};

type RouteName = { name: string; nameKey?: never };
type RouteNameKey = { nameKey: string; name?: never };

export type IRouteConfig = RouteConfigBase & (RouteName | RouteNameKey);

const routes: IRouteConfig[] = [
  {
    path: '/',
    name: 'Home',
    element: Home,
    layout: SandSwitchLayout,
    private: false,
    displayInNavigation: false, //TODO: Set to true when enabling authed home page
  },
  {
    path: '/login',
    name: 'Login',
    element: Login,
    layout: SandSwitchLayout,
    private: false,
    displayInNavigation: false,
  },
  {
    path: '/signup',
    name: 'Sign up',
    element: Signup,
    layout: SandSwitchLayout,
    private: false,
    displayInNavigation: false,
  },
  {
    path: '/trips',
    nameKey: 'sunshine.action.my_trips',
    element: MyTrips,
    layout: SandSwitchLayout,
    private: true,
    displayInNavigation: true,
  },
  {
    path: '/profile',
    nameKey: 'sunshine.action.profile',
    element: Profile,
    layout: SandSplitLayout,
    private: true,
    displayInNavigation: true,
  },
  {
    path: '/payout-management',
    nameKey: 'sunshine.action.payout_accounts',
    element: PayoutManagement,
    layout: SnowLayout,
    private: true,
    displayInNavigation: true,
  },
  {
    path: '/trips/:name',
    name: 'Trip Details',
    element: TripDetails,
    layout: BlankCanvasLayout,
    private: true,
    displayInNavigation: false,
  },
  {
    path: '/purchase-guarantee',
    nameKey: 'sunshine.action.purchase_weather_guarantee',
    nameDecoration: NewDecoration,
    element: PurchaseGuarantee,
    layout: SnowLayout,
    private: true,
    displayInNavigation: true,
  },
  {
    path: '/notification',
    name: 'Notification',
    element: Notification,
    layout: SnowLayout,
    private: true,
    displayInNavigation: false,
  },
];

export default routes;
